export default "__VITE_ASSET__DR5JvFD1__"